/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import AchievementHero from './AchievementHero';
import AchievementLevel from '../../../common/components/AchievementLevel';
import AchievementLevelUsers from './AchievementLevelUsers';
import Placeholder from 'flarum/common/components/Placeholder';
import Link from 'flarum/common/components/Link';
export default class AchievementPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.achievementId = m.route.param('id');
    app.history.push('achievement');
    this.bodyClass = 'App--achievement';
    this.loading = false;
    this.error = null;
    this.refresh();
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    const {
      achievement
    } = this;
    if (achievement) {
      app.setTitle(achievement.name());
    }
  }
  view() {
    const {
      achievement,
      loading,
      error
    } = this;
    return m("div", {
      className: "AchievementPage"
    }, m(AchievementHero, {
      achievement: achievement,
      loading: loading
    }), m("div", {
      className: "container"
    }, loading && m(LoadingIndicator, null), error && m(Placeholder, {
      text: app.translator.trans(error === 404 ? 'core.lib.error.not_found_message' : 'core.lib.error.generic_message')
    }), m("div", {
      className: "AchievementPage-levels"
    }, achievement?.levels().map(level => m(Link, {
      href: app.route('achievement-users', {
        levelId: level.id()
      })
    }, m("div", {
      className: "AchievementPage-level"
    }, m(AchievementLevel, {
      achievementLevel: level,
      showDesc: true
    }), m(AchievementLevelUsers, {
      achievementLevel: level
    })))))));
  }
  async refresh() {
    this.loading = true;
    this.error = null;
    m.redraw();
    try {
      this.achievement = await app.store.find('achievements', this.achievementId, {}, {
        // The inline Placeholder is the one error surface; core's default alert would duplicate it.
        errorHandler: () => {}
      });
    } catch (e) {
      // 404 covers both a missing and a hidden achievement; anything else is a generic failure.
      this.error = e?.status ?? 500;
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/components/AchievementPage', AchievementPage);